/*
 * Broadcast Theme
 *
 * Use this file to add custom Javascript to Broadcast.  Keeping your custom
 * Javascript in this fill will make it easier to update Broadcast. In order
 * to use this file you will need to open layout/theme.liquid and uncomment
 * the custom.js script import line near the bottom of the file.=2 
 */

(function () {
  // Add custom code below this line
  //FROM OLD THEME FOR MEGA MENU
  // js/custom-element/section/header/desktop-navigation.js

  function showMegaMenuDropdown() {
    const ariaAttr = $(".mega_menu_dropdown>.navlink").attr("aria-controls");
    $(`.mega_menu_dropdown #${ariaAttr}`).removeAttr("hidden");
  }
  function hideMegaMenuDropdown() {
    const ariaAttr = $(".mega_menu_dropdown>.navlink").attr("aria-controls");
    $(`.mega_menu_dropdown #${ariaAttr}`).attr("hidden", "");
  }
  $(".mega_menu_dropdown").on("mouseenter", showMegaMenuDropdown);
  $(".mega_menu_dropdown").on("mouseleave", hideMegaMenuDropdown);

  // Variable to store the Flickity instance
  var swatchFlkty = null;
  // Maximum width for mobile view
  var mobileMaxWidth = 768;

  function initializeFlickity() {
    const sectionContent = document.querySelector(
      ".shopify-section--color-swatches .section-content"
    );

    if (window.innerWidth <= mobileMaxWidth) {
      // Check if Flickity needs to be re-initialized
      if (!swatchFlkty) {
        // Remove any existing dots container to prevent stacking
        const existingDotsContainer = sectionContent.querySelector(
          ".flickity-page-dots"
        );
        if (existingDotsContainer) {
          existingDotsContainer.remove();
        }

        // Initialize Flickity
        swatchFlkty = new Flickity(sectionContent, {
          cellAlign: "left",
          contain: true,
          wrapAround: true,
          prevNextButtons: false,
          pageDots: false, // Disable default dots creation.
          freeScroll: false,
          groupCells: 3, // Adjust based on your requirement.
        });

        // Create custom dots container
        const dotsContainer = document.createElement("div");
        dotsContainer.className = "flickity-page-dots";
        sectionContent.appendChild(dotsContainer);

        // Create a dot (button) for each slide
        for (let i = 0; i < swatchFlkty.slides.length; i++) {
          const button = document.createElement("button");
          button.type = "button";
          button.className =
            "flickity-page-dot" + (i === 0 ? " is-selected" : "");
          if (i === 0) {
            button.setAttribute("aria-current", "step");
          }
          button.innerHTML = "View slide " + (i + 1);

          // Add click event listener to select the corresponding slide
          button.addEventListener("click", () => {
            swatchFlkty.select(i);
          });

          dotsContainer.appendChild(button);
        }

        // Update dots state when the slide changes
        swatchFlkty.on("change", (index) => {
          const buttons = dotsContainer.querySelectorAll("button");
          buttons.forEach((btn, i) => {
            if (i === index) {
              btn.classList.add("is-selected");
              btn.setAttribute("aria-current", "step");
            } else {
              btn.classList.remove("is-selected");
              btn.removeAttribute("aria-current");
            }
          });
        });
      }
    } else {
      // Destroy Flickity if the viewport is wider than mobile
      if (swatchFlkty) {
        swatchFlkty.destroy();
        swatchFlkty = null;

        // Remove the custom dots container
        const existingDotsContainer = sectionContent.querySelector(
          ".flickity-page-dots"
        );
        if (existingDotsContainer) {
          existingDotsContainer.remove();
        }
      }
    }
  }

  // Run on initial page load
  initializeFlickity();
  // Listen for window resize events
  window.addEventListener("resize", initializeFlickity);

  var videoContainerTimeOut = 15000; //15sec;
  var videoContainerIndex = 0;
  var intervalDelay = 100;
  var vidContainerInterval = setInterval(function () {
    var videoContainer = document.querySelector(
      "video-background[no-autoplay]"
    );
    if (videoContainer) {
      var video = videoContainer.querySelector("video");
      if (video) {
        console.log(video);
        // Remove any autoplay attribute, pause the video, and reset to start.
        video.removeAttribute("autoplay");
        video.pause();
        video.currentTime = 0;

        // Flag to track if the user has clicked.
        var userInteracted = false;
        // Backup the original play method.
        var originalPlay = video.play.bind(video);

        // Override play to allow actual playback only after user interaction.
        video.play = function () {
          if (userInteracted) {
            return originalPlay();
          } else {
            console.log("Prevented auto play because user hasn't clicked yet.");
            return Promise.resolve();
          }
        };

        // Use an Intersection Observer to check video visibility.
        var observer = new IntersectionObserver(
          function (entries) {
            entries.forEach(function (entry) {
              if (entry.isIntersecting) {
                if (!video.paused) {
                  // Only pause if it's playing.
                  video.pause();
                  console.log(
                    "Intersection Observer: Video in view and playing; paused and reset."
                  );
                }
              }
            });
          },
          { threshold: 0.5 }
        );
        observer.observe(videoContainer);

        // Add a scroll event listener that only pauses if the video is playing.
        window.addEventListener("scroll", function () {
          if (!video.paused) {
            video.pause();
            console.log("Scroll event: Video was playing; paused and reset.");
          }
        });
        video.addEventListener("click", function () {
          console.log("Clicked!");
        });
        clearInterval(vidContainerInterval);
      }
    }
    videoContainerIndex++;
    if (videoContainerIndex * intervalDelay >= videoContainerTimeOut) {
      clearInterval(vidContainerInterval);
    }
  }, 100); // Check every 100ms until the container is found

  //Klaviyo BIS
  const addToCartButton = document.querySelector('.product__submit__buttons [data-add-to-cart]'); // Replace with the correct class for your "Add to Cart" button
  const klaviyoButton = document.querySelector('.overtone-bis-button'); // Replace with the correct class for your Klaviyo BIS button
  const radioButtons = document.querySelectorAll('.radio__button input[type="radio"]');

  if (radioButtons.length) {
    function updateButtons() {
        // Find the checked radio button
        const selectedRadio = Array.from(radioButtons).find(radio => radio.checked);
  
        if (!selectedRadio) {
            console.error('No variant selected!');
            return;
        }
  
        const isSoldOut = selectedRadio.classList.contains('sold-out');
  
        if (isSoldOut) {
            addToCartButton.setAttribute('disabled', 'disabled');
            klaviyoButton.style.display = 'block'; // Show Klaviyo BIS button
        } else {
            addToCartButton.removeAttribute('disabled');
            klaviyoButton.style.display = 'none'; // Hide Klaviyo BIS button
        }
    }
  
    // Initial button state update
    updateButtons();
  
    // Add event listeners to radio buttons
    radioButtons.forEach(radio => {
        radio.addEventListener('change', updateButtons);
    });
  }
 
  // Custom Add To Cart
 const customAddToCartBtns = document.querySelectorAll(".btn[href='#MainContents']");
  if (customAddToCartBtns && addToCartButton) {
      let isBtnClicked = false;
      function observeCartChanges() {
          const cartObserver = new PerformanceObserver((list) => {
              list.getEntries().forEach((entry) => {
                  const isValidRequestType = ["xmlhttprequest", "fetch"].includes(entry.initiatorType);
                  const isCartChangeRequest = /\/cart\//.test(entry.name);

                  if (isValidRequestType && isCartChangeRequest && isBtnClicked) {
                      fetch("/cart.js")
                          .then((response) => response.json())
                          .then((cartData) => {
                              customAddToCartBtns.forEach((button) => {
                                  button.textContent = "Added!";
                                  button.disabled = false;
                                  button.classList.remove("loading");
                                  isBtnClicked = false;
                                  enableScroll();
                                  // Reset button text after a delay
                                  setTimeout(() => {
                                      button.textContent = "Add to Cart";
                                  }, 2000);
                              });
                          })
                          .catch((error) => {
                              console.error("Error fetching cart data:", error);
                          });
                  }
              });
          });

          // Observe resource entries
          cartObserver.observe({ entryTypes: ["resource"] });
      }
      console.log(customAddToCartBtns)
       customAddToCartBtns.forEach((customAddToCart) => {
        customAddToCart.addEventListener("click", (e) => {
          e.preventDefault();
          customAddToCart.disabled = true;
          customAddToCart.textContent = "Adding...";
          customAddToCart.classList.add("loading");
          addToCartButton.click();
          disableScroll();
          isBtnClicked = true;
        });
      });
      observeCartChanges();
  }
  function disableScroll() {
    scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop;
    scrollLeft =
    window.pageXOffset ||
    document.documentElement.scrollLeft,
    window.onscroll = function () {
        window.scrollTo(scrollLeft, scrollTop);
    };
  }
  function enableScroll() {
      window.onscroll = function () { };
  }
  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.
})();
document.addEventListener('rebuy.add', (event) => {
  const { product, widget } = event.detail;
  // Your logic here
  if(widget){
    document.querySelector('[data-cart-toggle]').click()
  }
});
window.addEventListener("ocu:cart:updated", e => {
    if(e.detail != null) return
    const  quick_add = document.querySelectorAll('.product-quick-add')
    if(quick_add){
      quick_add.forEach((item) => {
        setTimeout(() => {
          item.querySelector('.product-quick-add__close').click()
        }, 1000)
      })
    }
    // Add code here to detect when cart is opened
});
// document.addEventListener('ocu:cart:opened', function(event){
//   console.log('Cart drawer openned')
//     // document.querySelector('[data-cart-toggle]').click()
// });

// Create Subscription link
const subItem = document.createElement('li');
subItem.innerHTML = '<a href="https://overtone.co/a/loop_subscriptions/customer">Subscription</a>';

// Create Rewards link
const rewardsItem = document.createElement('li');
rewardsItem.innerHTML = '<a href="https://overtone.co/pages/rewards">Rewards</a>';

// Find "Order History"
const orderHistory = document.querySelector('.account-sidebar ul li:nth-child(1)');

// Insert Subscription after Order History
if(orderHistory){
orderHistory.insertAdjacentElement('afterend', subItem);
}
// Insert Rewards after Subscription
subItem.insertAdjacentElement('afterend', rewardsItem);
// const button = document.querySelector('.account-main a button');
// if (button) {
//     button.className = 'btn btn--small btn--solid btn--black'; // Replace existing classes
//     button.textContent = ' Manage Subscription'; // Update button text
//     button.style.maxWidth = '250px'; // Set max width
//     button.style.width = '100%'; // Set width to 100%
// }

const wrapperDiv = document.querySelector('.account-main a')?.parentElement;

if (wrapperDiv) {
  wrapperDiv.classList.add('btn__wrapper');
  wrapperDiv.innerHTML = ''; // Clear any existing content

  // Set flex styles
  wrapperDiv.style.display = 'flex';
  wrapperDiv.style.gap = '8px';

  // Manage Subscription button
  const manageBtn = document.createElement('a');
  manageBtn.href = '/a/loop_subscriptions/auth?customer_id=74839';
  manageBtn.textContent = 'Manage Subscription';
  manageBtn.className = 'btn btn--small btn--solid btn--black';
  manageBtn.style.maxWidth = '250px';
  manageBtn.style.width = '100%';

  // Rewards button
  const rewardsBtn = document.createElement('a');
  rewardsBtn.href = 'https://overtone.co/pages/rewards';
  rewardsBtn.textContent = 'Rewards';
  rewardsBtn.className = 'btn btn--small btn--solid';
  rewardsBtn.style.backgroundColor = '#954bc2';
  rewardsBtn.style.color = '#fff';
  rewardsBtn.style.border = 'none'; // Remove border
  rewardsBtn.style.maxWidth = '160px';
  rewardsBtn.style.width = '100%';

  // Append both
  wrapperDiv.appendChild(rewardsBtn);
  wrapperDiv.appendChild(manageBtn);
}
const bisButton = document.querySelector('.overtone-bis-button'); // adjust selector if needed
if (bisButton) {
  bisButton.style.display = 'none';
}

const productFaqWrapper = document.querySelector('.product-faq-wrapper');

if(productFaqWrapper){
  productFaqWrapper.querySelectorAll('.accordion-item h3').forEach((header) => {
    header.addEventListener('click', () => {
      const accordionItem = header.closest('.accordion-item');

      if (!accordionItem) return;

      if (accordionItem.hasAttribute('open')) {
        accordionItem.removeAttribute('open');
      } else {
        accordionItem.setAttribute('open', '');
      }
    });
  });
}


const imageAnchorLink = document.querySelectorAll('.image-anchor-link');
const achorLinkTimeout =  5000
let  anchorLinkI = 0
const anchorLinkInterval = setInterval(() => {
  anchorLinkI++;
  if(anchorLinkI > achorLinkTimeout){
    clearInterval(anchorLinkInterval)
  }
  if(imageAnchorLink.length > 0){
    clearInterval(anchorLinkInterval)
    imageAnchorLink.forEach(element => {
      const col = element.querySelectorAll('.column__inner');
      col.forEach(el => {
        const anchorImage =  el.querySelector('.image-wrapper');
        const anchorText = el.querySelector('.column__heading').innerText;
        const slug = textToSlug(anchorText)
        
        anchorImage.addEventListener('click', function(e){
          e.preventDefault();
          const prod_variant = document.querySelector(`.product__siblings tooltip-component[class*="swatch-${slug}"] a`)
          console.log("PRODUCT VARIANT  ", prod_variant)
          if(prod_variant){
            prod_variant.click();
          }
          window.scrollTo({
            top: 0,
            behavior: 'smooth'
          });
        })
      });
    });
  }
}, 100)

const fragranceCarousel = document.querySelectorAll('.fragrance-image-carousel');

const fragranceTimeout =  5000
let  fragranceI = 0
const fragranceInterval = setInterval(() => {
  fragranceI++;
  if(fragranceI > fragranceTimeout){
    clearInterval(fragranceInterval)
  }
  if(fragranceCarousel.length > 0){
    clearInterval(fragranceInterval)
    fragranceCarousel.forEach(element => {
      const col = element.querySelectorAll('.column__inner');
      col.forEach(el => {
        const anchor =  el.querySelector('.column__btn a');
        const anchorText = anchor.getAttribute('href'); 
        const slug = anchorText.replace('#', ''); 
        console.log(slug)
        anchor.addEventListener('click', function(e){
          e.preventDefault();
          const prod_variant = document.querySelector(`.product__siblings tooltip-component[class*="swatch-${slug}"] a`)
          console.log("PRODUCT VARIANT  ", prod_variant)
          if(prod_variant){
            prod_variant.click();
          }
          window.scrollTo({
            top: 0,
            behavior: 'smooth'
          });
        })
      });
    });
  }
}, 100)

const textToSlug = (str) => {
  console.log(str)
  return str
    .toLowerCase()
    .trim()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/[^\w\s-]/g, '')
    .replace(/[\s_-]+/g, '-')
    .replace(/^-+|-+$/g, '');
};

const ingredientLink = document.querySelector("a[href='#IngredientList']");
if(ingredientLink){
    ingredientLink.addEventListener('click', function(e){
    e.preventDefault();
    const ingredientsAcc = document.querySelector('.product-accordion-section[aria-label="Ingredients"]');

    const viewportTop = ingredientsAcc.getBoundingClientRect().top;
    const absoluteTop = viewportTop + window.scrollY;

    const targetScrollPosition = absoluteTop - 128;

    window.scrollTo({
      top: targetScrollPosition,
      behavior: 'smooth'
    });

    document.querySelector('.product-accordion-section[aria-label="Ingredients"] [data-collapsible-trigger]').click()
    if(document.querySelector('.product-accordion-section[aria-label="Ingredients"] .toggle-ellipsis__actions button')){
      document.querySelector('.product-accordion-section[aria-label="Ingredients"] .toggle-ellipsis__actions button').click()
    }
  })
}
if (window.KlaviyoOnsite && window.klaviyo) {
  var currentVariantId = document.querySelector('input[name="id"]').value;
  window.klaviyo.push(["openForm", { trigger: "bis", variantId: currentVariantId }]);
}
// Cart Drawer Loop Subscription

(function () {
  const lastVariants = new Map();

  document.addEventListener('change', function (event) {
    const input = event.target;

    if (!input.matches('input[name="id"]')) return;

    const variantId = input.value;
    const form = input.form;

    if (!form) return;

    const productId = form.dataset.loopProductId;

    if (!productId) return;

    if (lastVariants.get(productId) === variantId) return;

    lastVariants.set(productId, variantId);

    if (
      typeof getLoopProductData !== 'function' ||
      typeof loopVariantChanged !== 'function'
    ) return;

    const productData = getLoopProductData(productId);

    if (!productData) return;

    loopVariantChanged({
      loopProduct: productData,
      variantId: variantId
    });
  });
})();
